import type * as ngCore from '@angular/core'
import * as ngMatCore from '@angular/material/core'

export const DATE_LOCALE = 'en-US'

export const DATE_MATERIAL_FORMATS: ngMatCore.MatDateFormats = {
  display: {
    dateA11yLabel: { day: 'numeric', month: 'long', year: 'numeric' },
    dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' },
    monthYearA11yLabel: { month: 'long', year: 'numeric' },
    monthYearLabel: { month: 'short', year: 'numeric' },
  },
  parse: {
    dateInput: null,
  },
}

export const DATE_MATERIAL_PROVIDERS: ngCore.Provider[] = [
  {
    provide: ngMatCore.MAT_DATE_LOCALE,
    useValue: DATE_LOCALE,
  },
  ...ngMatCore.provideNativeDateAdapter(DATE_MATERIAL_FORMATS),
]
